import { makeFetchSlice, fetchDataThunk } from 'app/redux-fetch'
import { AppDispatch } from 'app/store'
import { fetchHomeActiveConfig } from 'features/home/api'
import { HOME_ACTIVE_CONFIG_ENERGY_DATA_REDUCER_NAME } from 'features/home/consts'

const homeActiveConfigEnergyDataSlice = makeFetchSlice(
  HOME_ACTIVE_CONFIG_ENERGY_DATA_REDUCER_NAME
)
export const homeActiveConfigEnergyDataReducer = homeActiveConfigEnergyDataSlice.reducer
export const homeActiveConfigEnergyDataActions = homeActiveConfigEnergyDataSlice.actions

export const fetchHomeActiveConfigEnergyDataThunk = (homeId: string, redirect: boolean) => {
  return async (dispatch: AppDispatch) => {
    try {
      await fetchDataThunk({
        dispatch,
        actions: homeActiveConfigEnergyDataActions,
        asyncFunc: () =>
          fetchHomeActiveConfig(homeId, {
            type: 'energyHistory',
            redirect: redirect,
          }),
      })
    } catch (error) {
      console.log('Error fetching home active energy data config', error)
    }
  }
}

